export default __webpack_public_path__ + "static/media/03-main.3356d7c3.jpg";